module.exports = __webpack_public_path__ + "img/Benedito.1b971a5c.jpeg";